import { Box } from "@mui/material";

import styled from "styled-components";

export const PageContainer = styled(Box)`
    padding: 45px 30px 30px 30px;
    position: relative;
    @media (max-width: 600px) {
        // smaller padding
        padding: 20px 0 10px 0 !important;
    }
`;

export const Title = styled(Box)`
    font-size: 36px;
    font-weight: 700;
    line-height: 1;
    color: black;
`;

export const Subtitle = styled(Box)`
    font-size: 16px;
    color: black;
    margin-bottom: 15px;
`;
export default { PageContainer, Title, Subtitle };
